import { createStore } from '@stencil/store';

import { baseVehicleState } from '../utils/utils.vehicle';

const initialState = {
  ...baseVehicleState,
  bodyStyle: '',
  vehicleType: 'sedan',
  numberOfRows: 1,
  numberOfDoors: 2,
  isThirdRowOptional: false,
};

const { on, onChange, state, reset } = createStore(initialState);

export { initialState, on, onChange, state, reset };
export default state;
